import Container from "../../components/ui/Container.js"
import "./CrosswordView.scss"

import { useSteps } from "../../hooks/useSteps"
import { useEffect, useMemo, useRef, useState } from "react"
import { GoBackBtn } from "../../components/games/GoBackBtn"

import { useParams } from "react-router"
import { SeaAnimals } from "../../components/games/seaanimals/SeaAnimals.js"
import { useWindowDimensions } from "../../hooks/useWindowDimensions.js"
import { Modal } from "../../components/ui/modal/Modal.js"
import { SeaAnimalsEditor } from "../../components/games/seaanimals/SeaAnimalsEditor.js"
import { config } from "../../config.js"

import { say } from "../../helpers/speech.js"
import { Switch } from "../../components/ui/Switch.js"
import { useTranslation } from "react-i18next"

const ElegirNombre = ({ setNombre }) => {
  const nombreEl = useRef(null)

  const { t } = useTranslation()

  return (
    <>
      <div className="title pt-4">
        {t(`games.sea_animals.tell_me_your_name`)}
      </div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex justify-content-center align-items-center flex-row">
          <input
            ref={nombreEl}
            type="text"
            style={{ textAlign: "center" }}
            placeholder={t(`games.sea_animals.anonymous`)}
          />
        </div>
        <div className="d-flex justify-content-center align-items-center flex-row">
          <button
            onClick={() => setNombre(nombreEl.current.value)}
            className="btn azul my-3">
            {t(`ui.btns.next`)}
          </button>
        </div>
      </div>
    </>
  )
}

const ElegirSala = ({ status, wordsets, setSala }) => {
  // componente encargado de mostras las salas

  const [pickedWordset, setPickedWordset] = useState(
    wordsets.length ? wordsets[0] : ""
  )

  const onOptionChange = (e) => {
    setPickedWordset(e.target.value)
  }

  // modal para elegir el wordset
  const showModalPickWordset = useState(false)

  const footerModal = () => {
    return (
      <>
        <button
          type="button"
          onClick={() => {
            setSala(-1, pickedWordset)
          }}
          className="btn btn-primary">
          {t(`ui.btns.pick`)}
        </button>
      </>
    )
  }

  const pickWordset = () => {
    showModalPickWordset[1](true)
  }

  const name = (id) => status.players.find((u) => u.id === id).nick

  const { t } = useTranslation()

  return (
    <>
      <Modal
        show={showModalPickWordset}
        header={<center>{t(`games.sea_animals.pick_wordset`)}</center>}
        closeBtn={true}
        body={
          <center>
            <div className="multiSelect">
              {wordsets.map((wordset, ix) => (
                <div key={ix} onClick={() => setPickedWordset(wordset)}>
                  <input
                    type="radio"
                    name="topping"
                    value={wordset}
                    id={wordset}
                    checked={pickedWordset === wordset}
                    onChange={onOptionChange}
                  />
                  <label htmlFor={wordset}>{wordset}</label>
                </div>
              ))}
            </div>
          </center>
        }
        footer={footerModal()}
      />
      <div className="title pt-4">{t(`games.sea_animals.select_a_room`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex flex-row flex-wrap justify-content-center">
          {/* usuarios online */}
          <div className="col-lg-4 col-12">
            <h6>
              {t("games.sea_animals.online", { count: status.players.length })}
            </h6>
            {status.players.map((u, uix) => (
              <div key={uix} className="row">
                &bull;&nbsp;{u.nick}
              </div>
            ))}
          </div>

          {/* salas */}
          <div className="col-lg-8 col-12">
            <div className="d-flex flex-row flex-wrap justify-content-center">
              {/* existentes */}
              {status.rooms.map((sala, six) => (
                <div key={six} className="col-lg-4 col-6 py-1">
                  <div
                    className="box category"
                    onClick={() => setSala(sala.id, "")}>
                    <span className="mini-label">{sala.wordset}</span>
                    <span>
                      {t("games.sea_animals.room")} <b>{sala.id + 1}</b>
                    </span>
                    <div>
                      <center>
                        {sala.players.map((id, uix) => name(id)).join(" & ")}
                      </center>
                    </div>
                  </div>
                </div>
              ))}

              {/* crear nueva */}
              <div className="col-lg-4 col-6 py-1">
                <div
                  style={{ height: "100%" }}
                  className="box category"
                  onClick={() => pickWordset()}>
                  <span>{t("games.sea_animals.empty_room")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const Esperando = () => {
  const [dots, setDots] = useState("")

  useEffect(() => {
    const timeoutDots = setInterval(
      () => setDots((c) => (c.length === 3 ? "" : c + ".")),
      1000
    )

    return () => {
      clearInterval(timeoutDots)
    }
    // eslint-disable-next-line
  }, [])

  const { t } = useTranslation()

  return (
    <>
      <div className="d-flex justify-content-center align-items-center flex-row">
        <div className="col-6">
          <div className="title py-5">
            {t(`games.sea_animals.waiting`)}
            <br />
            {dots}
          </div>
        </div>
      </div>
    </>
  )
}

// const SeaAnimalsID = ({ id }) => {
//   const [ data, isPending, err ] = useFetch({
//     url: `${config.apiUrl}/games/${id}`
//   })

//   const showModalGanaste = useState(false)
//       , handleWin        = () => showModalGanaste[1](true)

//   if (isPending && !err)
//     return (
//       <div className="row my-5 py-5">
//         <center>
//           Cargando...
//         </center>
//       </div>
//     )

//   if (err)
//     return <NotFound />

//   return <>
//     <ModalGanaste show={showModalGanaste} />
//     {data && <CrosswordsGame
//                 data={data.entries}
//                 size={data.size}
//                 winCallback={handleWin}
//               />}
//     </>
// }

const SeaAnimalsLoader = ({
  me,
  op,
  turno,
  confirmationCell,
  size,
  animations,
  setAnimations,
  coords,
  myShips,
  opShips,
  winCallback,
  bombMe,
  bombOp,
  onClickMe,
  onClickOp,
  askForConfirmation,
  setAskForConfirmation,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <SeaAnimals
        me={me}
        op={op}
        confirmationCell={confirmationCell}
        turno={turno}
        size={size}
        myShips={myShips}
        opShips={opShips}
        animations={animations}
        coords={coords}
        winCallback={winCallback}
        bombMe={bombMe}
        bombOp={bombOp}
        onClickMe={onClickMe}
        onClickOp={onClickOp}
      />

      <div className="d-flex justify-content-center mt-5 mb-3">
        <table style={{ width: "fit-content" }}>
          <tbody>
            <tr>
              <td>
                <Switch status={animations} setStatus={setAnimations} />
              </td>
              <td className="px-2 py-1">
                {t(`games.sea_animals.animated_background`)}
              </td>
            </tr>
            <tr>
              <td>
                <Switch
                  status={askForConfirmation}
                  setStatus={setAskForConfirmation}
                />
              </td>
              <td className="px-2 py-1">
                {t(`games.sea_animals.ask_for_confirmation`)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

const RandomSeaAnimalsPicker = () => {
  const { t } = useTranslation()

  const tamano = 6

  let [steps] = useSteps(["nombre", /* "tamano", */ "sala", "config", "ready"]),
    setNombre = steps.setter("nombre"),
    // , setTamano = steps.setter("tamano")
    setSala = steps.setter("sala"),
    setConfig = steps.setter("config"),
    setReady = steps.setter("ready")

  // desactivo la animacion del oceano en mobile
  const { width } = useWindowDimensions(),
    defaultAnim = width >= 1366 ? true : false,
    [animations, setAnimations] = useState(defaultAnim),
    [askForConfirmation, setAskForConfirmation] = useState(true)

  // modal de fin de juego
  const showModalGanaste = useState(false),
    handleWin = () => {
      showModalGanaste[1](true)
    },
    footerModalCompletado = () => {
      const handleRetry = () => {
        steps.goTo(1)
        websocket.current.send(JSON.stringify({ tipo: "leave" }))
        showModalGanaste[1](false)
      }
      return (
        <>
          <button
            type="button"
            onClick={handleRetry.bind(this)}
            className="btn btn-primary">
            {t(`ui.btns.retry`)}
          </button>
        </>
      )
    }

  // modal cancelado
  const showModalCancelado = useState(false),
    [canceladoText, setCanceladoText] = useState(""),
    footerModalCancelado = () => {
      const handleRetry = () => {
        if (steps) steps.goTo(1)
        showModalGanaste[1](false)
        showModalCancelado[1](false)
      }
      return (
        <>
          <button
            type="button"
            onClick={handleRetry.bind(this)}
            className="btn btn-primary">
            {t("ui.btns.ok")}
          </button>
        </>
      )
    }

  // modal error
  const showModalError = useState(false),
    [errorText, seterrorText] = useState(""),
    footerModalError = () => {
      const handleRetry = () => {
        showModalError[1](false)
      }
      return (
        <>
          <button
            type="button"
            onClick={handleRetry.bind(this)}
            className="btn btn-primary">
            {t("ui.btns.ok")}
          </button>
        </>
      )
    }

  // modal confirmation
  const showModalConfirmation = useState(false),
    [casilla, setCasilla] = useState(null),
    BodyModalConfirmation = () => {
      const text = `${coords.xcoords[casilla.x]} ${coords.ycoords[casilla.y]}`
      return (
        <>
          <center>{text}</center>
        </>
      )
    },
    FooterModalConfirmation = () => {
      const handleOk = () => {
        const copy = { ...casilla }
        sendBomb(copy)
        setCasilla(null)
        showModalConfirmation[1](false)
      }
      const handleCancel = () => {
        setCasilla(null)
        showModalConfirmation[1](false)
      }
      return (
        <>
          <div className="d-flex justify-content-center w-100">
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-danger me-3">
              {t(`ui.btns.cancel`)}
            </button>
            <button
              type="button"
              onClick={handleOk}
              className="btn btn-primary">
              {t(`games.sea_animals.correct`)}
            </button>
          </div>
        </>
      )
    }

  // estado del juego & server
  const [me, setMe] = useState({
      id: -1,
      nick: t(`games.sea_animals.anonymous`),
    }),
    [wordsets, setWordsets] = useState([]),
    [op, setOp] = useState({ id: NaN, nick: t(`games.sea_animals.anonymous`) }),
    [turno, setTurno] = useState(NaN),
    // , [myShips, setMyShips] = useState(null) // <- no hace falta
    [opShips, setOpShips] = useState([]),
    [coords, setCoords] = useState(null),
    [status, setStatus] = useState({
      players: [],
      rooms: [],
    })

  // socket + protocolo
  const websocket = useRef()

  // funciones para manjear los paneles
  // e.g., bombMe(1,2) hace que el avion del panel 1 bombarde en x=1 y=2
  // onClickMe va a ser llamado cuando se clickee el panel 1
  const bombMe = useRef(null)
  const bombOp = useRef(null)
  const sendBomb = (pos) => {
    const msg = `{"tipo": "bomb", "cont": [${pos.y},${pos.x}]}`
    websocket.current.send(msg)
  }
  const sendConfirmationRequest = (pos) => {
    const msg = `{"tipo": "conf_req", "cont": [${pos.y},${pos.x}]}`
    websocket.current.send(msg)
  }
  const onClickOp = (pos) => {
    // AHORA: que no haga nada
    // ANTES: clickeaba op -> y decia la cela
    // if (coords !== null && Object.keys(coords).length > 0) {
    //   const x = coords.xcoords[pos.x]
    //       , y = coords.ycoords[pos.y]
    //       , text = `${x} ${y}`
    //   say(text)
    // }
  }
  const onClickMe = (pos) => {
    // solo sii NO es mi turno
    const habilitado = turno !== me.id
    if (habilitado) {
      sendConfirmationRequest(pos)
      // if (askForConfirmation) {
      //   const text = `${coords.xcoords[pos.x]} ${coords.ycoords[pos.y]}`
      //   say(text)
      //   setCasilla(pos)
      //   showModalConfirmation[1](true)
      // } else sendBomb(pos)
    }
  }

  const handleMsg = useMemo(
    () => (event) => {
      const msg = JSON.parse(event.data)
      try {
        switch (msg.tipo) {
          case "welcome":
            setMe({ id: msg.cont.id, nick: msg.cont.nick })
            setWordsets(msg.cont.wordsets)
            break

          case "update":
            setStatus(msg.cont)
            break

          case "start":
            setCoords(msg.cont.coords)
            const op = msg.cont.players.find((u) => parseInt(u.id) !== me.id)
            setOp(op)
            // console.log("<< start.turno", msg.cont.turno)
            setTurno(parseInt(msg.cont.turno))
            setOpShips(msg.cont.ships[op.id])
            setReady(true)
            break

          case "reveal":
            {
              const y = parseInt(msg.cont.pos[0]),
                x = parseInt(msg.cont.pos[1])

              if (parseInt(msg.cont.pid) === me.id) bombMe.current(x, y)
              else {
                bombOp.current(x, y)
                // const isDunked = msg.cont.dunked !== false
                // if (isDunked) {
                //   console.log("hundi a", msg.cont.dunked)
                //   setOpShips(current =>
                //     current.concat(
                //       msg.cont.ships[opId]
                //     )
                //   )
                // }
              }

              // console.log("<< reveal.turno", msg.cont.turno)
              setTurno(parseInt(msg.cont.turno))
            }
            break

          case "conf_req":
            // console.log("me llego ---->", msg)
            {
              const y = parseInt(msg.cont[0]),
                x = parseInt(msg.cont[1]),
                pos = { x, y }

              const text = `${coords.xcoords[x]} ${coords.ycoords[y]}`
              say(text)
              setCasilla(pos)
              showModalConfirmation[1](true)
            }
            break

          case "cancelled":
            setCanceladoText(msg.cont)
            showModalCancelado[1](true)
            break

          case "error":
            seterrorText(msg.cont)
            showModalError[1](true)
            break

          default:
            break
        }
      } catch (err) {
        console.log(err)
      }
    },
    [
      me,
      setReady,
      showModalCancelado,
      showModalError,
      coords,
      showModalConfirmation,
    ]
  )

  // conexion
  useEffect(() => {
    websocket.current = new WebSocket(config.wsUrl + "/seaanimals")
    return () => {
      websocket.current.close()
    }
  }, [])

  // listener
  useEffect(() => {
    websocket.current.addEventListener("message", handleMsg)

    return () => {
      websocket.current.removeEventListener("message", handleMsg)
    }
  }, [me, handleMsg])

  // handlers
  const handleNombreInput = (nombre) => {
    if (nombre.length > 0) {
      const msg = `{"tipo": "setNick", "cont": "${nombre}"}`
      websocket.current.send(msg)
    }
    setNombre(nombre)
  }

  const handleSalaInput = (sala, wordset = "") => {
    const laSalaExiste = sala !== -1,
      estaLlena =
        laSalaExiste &&
        status.rooms.find((s) => s.id === sala).players.length === 2

    if (estaLlena) {
      seterrorText(t(`games.sea_animals.select_a_room`))
      showModalError[1](true)
      return
    }

    const msg = {
      tipo: "join",
      cont: {
        roomID: sala,
        wordset: wordset,
      },
    }

    websocket.current.send(JSON.stringify(msg))
    setSala(sala)
  }

  const handleShipsInput = (ships) => {
    const msg = {
      tipo: "setShips",
      cont: ships,
    }

    websocket.current.send(JSON.stringify(msg))
    setConfig(ships)
  }

  const handleStepClick = (ix) => {
    // 1 es el index del paso "elegi sala" en el hook "useSteps"
    const yaHabiaElegidoLaRoom = steps.currentIx > 1,
      eligioIrAtras = ix < steps.currentIx,
      saleDeLaSala =
        (yaHabiaElegidoLaRoom && eligioIrAtras) || steps.currentIx === -1

    if (!saleDeLaSala) return

    const msg = {
      tipo: "leave",
    }

    websocket.current.send(JSON.stringify(msg))
  }

  // const {t} = useTranslation()
  // {t(`games.sea_animals.select_a_room`)}

  return (
    <>
      <Modal
        show={showModalGanaste}
        header={<center>{t(`games.sea_animals.done`)}</center>}
        closeBtn={false}
        body={
          <center>
            <h3>{t(`games.sea_animals.good_job`)}</h3>
          </center>
        }
        footer={footerModalCompletado()}
      />

      <Modal
        show={showModalCancelado}
        closeBtn={false}
        header={<center>{t(`games.sea_animals.its_over`)}</center>}
        body={<center>{canceladoText}</center>}
        footer={footerModalCancelado()}
      />

      <Modal
        show={showModalError}
        closeBtn={false}
        header={<center>Error</center>}
        body={<center>{errorText}</center>}
        footer={footerModalError()}
      />

      {showModalConfirmation[0] && (
        <Modal
          show={showModalConfirmation}
          closeBtn={true}
          header={<center>{t(`games.sea_animals.confirmation`)}</center>}
          body={<BodyModalConfirmation />}
          footer={<FooterModalConfirmation />}
        />
      )}

      <GoBackBtn steps={steps} onChange={handleStepClick} />

      {steps.at("nombre") && <ElegirNombre setNombre={handleNombreInput} />}

      {/* {steps.at("tamano") &&
        <ElegirTamano
          setTamano={setTamano} /> } */}

      {steps.at("sala") && (
        <ElegirSala
          status={status}
          wordsets={wordsets}
          setSala={handleSalaInput}
        />
      )}

      {steps.at("config") && (
        <SeaAnimalsEditor
          size={tamano}
          setConfig={handleShipsInput}
          animations={animations}
          setAnimations={setAnimations}
        />
      )}

      {steps.at("ready") && <Esperando />}

      {steps.done && (
        <SeaAnimalsLoader
          me={me}
          op={op}
          confirmationCell={casilla}
          turno={turno}
          size={tamano}
          coords={coords}
          myShips={steps.data.config}
          opShips={opShips}
          animations={animations}
          setAnimations={setAnimations}
          winCallback={handleWin}
          bombMe={bombMe}
          bombOp={bombOp}
          onClickMe={onClickMe}
          onClickOp={onClickOp}
          askForConfirmation={askForConfirmation}
          setAskForConfirmation={setAskForConfirmation}
        />
      )}
    </>
  )
}

const SeaAnimalsViewOnline = () => {
  const { id } = useParams()

  return (
    <Container>
      {id ? (
        // ? <CrosswordsID id={id} />
        <RandomSeaAnimalsPicker />
      ) : (
        <RandomSeaAnimalsPicker />
      )}
    </Container>
  )
}

export default SeaAnimalsViewOnline
